<template>
  <div>
    <div class="ml-5 mt-5">
      <span class="display-1">Event Form</span>
    </div>
    <div v-if="SuccessMessage" class="ml-4 mt-5 d-flex justify-content-center align-items-center text-center btn-success success-msg">
      <span class="fs-3 text-center">Event Added Successfully</span>
    </div>

    <v-form ref="form" v-model="valid" class="ml-5 mr-5 w-50 form-width w100 ">
      <div v-if="!isLockSendNewEvent">
        <v-select v-model="type" :items="ActivityType" :rules="[required]" label="Type"
                  @change="handleChangeEventType"
        ></v-select>

        <v-text-field v-model="callId" v-if="isShowCallId_form"  label="Call ID"></v-text-field>

        <v-text-field v-model="name" :rules="[required]" label="Name"></v-text-field>
        <div v-if="this.ErrorMsg" class="alert-text">
          <span>{{ErrorMsg}}</span>
        </div>

        <input type="datetime-local" id="my-date" v-model="selectedDate" required >
        <v-textarea v-model="note"  label="Note"></v-textarea>

      </div>

      <v-btn v-if="!isEditMode" class="mr-4 white--text" @click="submitForm" color="indigo" block :disabled="isLockSendNewEvent">
        Add New Event
      </v-btn>

      <v-btn v-if="isEditMode" class="mr-4 white--text mt-5" @click="saveForm" color="indigo" block :disabled="disabled">
        Save
      </v-btn>

      <v-btn class="mr-4 white--text mt-5" @click="skipForm" color="indigo" block :disabled="disabled">
        Skip
      </v-btn>


    </v-form>
    <div v-if="ErrorMsgAddEvent" class="ml-4 mt-4 alert warning">
      <span class="alert">Error create event: {{ErrorMsgAddEvent}}</span>
    </div>
  </div>
</template>

<script>
import instance from "@/api/axios-auth";
import RuralEventType_Helper from "@/utils/Load_RuralEventType";

export default {
  name: "RuralEvent4ContactForm",
  components: {

  },
  props: {
    contact_id: {
      type: Number,
      default: 0
    },
    event_id:{
      type:Number,
      default:0
    }
  },

  data: () => ({
    eventTypeHelper:new RuralEventType_Helper(),
    disabled:false,
    selectedDate:null,
    isShowCallId_form:false,
    ErrorMsgAddEvent:null,
    SuccessMessage:false,
    isLockSendNewEvent:false,
    callId:'',
    valid: true,
    isEditMode:false,
    ErrorMsg:false,

    types: ['Type 1', 'Type 2', 'Type 3'],
    ActivityType: [
      {text: 'Call', value: '1'},
      {text: 'SCRAP_DATA_EVENT', value: '2'},
      {text: 'Lanch and Learn', value: '3'},
      {text: 'Coupon', value: '4'},
    ],
    type: '',
    name: '',
    date: null,
    note: '',
  }),
  mounted() {
    // This method is called when the component has been mounted
    this.ActivityType.sort((a, b) => {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      return 0;
    });

    if (this.event_id){
      this.load_event_data(this.event_id)
      this.isEditMode = true;
    }

    this.eventTypeHelper.getRuralEventType().then(res=>{
      console.log(res);
      this.ActivityType = this.eventTypeHelper.MakeSelectorData();
    });

  },

  methods: {

    required: value => !!value || 'Required.',
    submitForm: function () {
      if (! this.selectedDate){
        this.ErrorMsg='Please select date.'
        return;
      }
      if (this.$refs.form.validate()) {
        const url = `/rural/rural_add_event_4_contact`
        let formpayload = this.makeFormPayload()
        this.isLockSendNewEvent = true;

        instance.post(url, formpayload).then(resp => {

          this.clearForm();
          console.log(resp.status)
          this.SuccessMessage = true;

          setTimeout(()=>{
            this.isLockSendNewEvent = false;
            this.SuccessMessage = false;
            this.$emit('endAddedEvents', 'Event');
          }, 3000)
        }).catch(error=>{
          this.ErrorMsgAddEvent = error.response.data;
          this.isLockSendNewEvent = false;
        })
      }
    },

    saveForm(){

    },
    skipForm:function (){
        this.isLockSendNewEvent = true;
      this.$emit('endAddedEvents', 'Event');
    },

    makeFormPayload(){
      const res = {
            ActivityType: this.type,
            DateEvent:this.selectedDate,
            Note:this.note,
            Name:this.name,
            ContactId:this.contact_id,
            CallId:this.callId,
          }
      return res;
  },
    handleChangeEventType(select_item){
      if ( select_item == 1){
        this.isShowCallId_form = true;
      } else {
        this.isShowCallId_form = false;
      }
      console.log(select_item)

    },
    load_event_data(id_event){
      instance.get('/rural/load-event-info/'+id_event).then(response => {
        console.log(response.data)
        this.name = response.data.data['name']
        console.log(response.data.data['type_id'])
        this.type = response.data.data['type_id'].toString()
        this.type='2';
        this.selectedDate = this.formatDateForInput(response.data.data['date_event'])
        if (response.data.data['call_id'])
          this.callId = response.data.data['call_id']
      });
    },

    formatDateForInput(dateString) {
      const date = new Date(dateString);
      const pad = (number) => number.toString().padStart(2, '0');

      return [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate())
      ].join('-') + 'T' + [
        pad(date.getHours()),
        pad(date.getMinutes())
      ].join(':');
    },

    clearForm(){
      this.note='';
      this.date = null;
      this.type = null;
      this.callId = null;
      this.name = null;
    }
}
}
</script>

<style scoped>
.text-center{
  justify-content: center;
}

.success-msg{
  color: #008000;
}
.alert {
  padding: 15px;
  background-color: #f44336; /* Red */
  color: white;
  opacity: 1;
  transition: opacity 0.6s; /* 600ms to fade out */
}

.alert-text{
  color: #f44336;
}

.alert.warning {background-color: #ff9800;} /* Orange */
</style>
